import React, { useRef } from "react";
// import "./TemplatComman.css";
import bannerImage from "../../../../Images/theme-38-banner.png";
import logoImage from "../../../../Images/38logo.png";
import testimonialImage from "../../../../Images/avatar.png";
import "./Theme38.css";
import { useState } from "react";
import TestimonialWrapper from "../../../Components/Testimonials/TestimonialWrapper";
import PortfolioWrapper from "../../../Components/Portfolios/PortfolioWrapper";
import CalanderIconn from "../../../../Images/DarkcalendarIcondays.png";
import GalleryCarousel from "./GalleryCarousel";
const Theme38Template = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const galleryArray1 = [
    {
        "id": 736,
        "business_id": 2612,
        "image": "1728978841238theme-38-g1.png",
        "created_by": 202,
        "created_at": "2024-10-15T07:54:01.000Z",
        "updated_at": "2024-10-15T07:54:01.000Z"
    },
    {
        "id": 737,
        "business_id": 2612,
        "image": "1728978854259theme-38-g2.png",
        "created_by": 202,
        "created_at": "2024-10-15T07:54:14.000Z",
        "updated_at": "2024-10-15T07:54:14.000Z"
    },
    {
        "id": 738,
        "business_id": 2612,
        "image": "1728978861266theme-38-g3.png",
        "created_by": 202,
        "created_at": "2024-10-15T07:54:21.000Z",
        "updated_at": "2024-10-15T07:54:21.000Z"
    }
]

const galleryArray = [
  {
    id: 60,
    business_id: 10,
    image: "1701329881279Rectangle6.jpg",
    created_by: 72,
    created_at: "2023-11-30T07:38:01.000Z",
    updated_at: "2023-11-30T07:38:01.000Z",
  },
  {
    id: 61,
    business_id: 10,
    image: "1701329883848Rectangle7.jpg",
    created_by: 72,
    created_at: "2023-11-30T07:38:03.000Z",
    updated_at: "2023-11-30T07:38:03.000Z",
  },
  {
    id: 62,
    business_id: 10,
    image: "1701329887518Rectangle597.jpg",
    created_by: 72,
    created_at: "2023-11-30T07:38:07.000Z",
    updated_at: "2023-11-30T07:38:07.000Z",
  },
  {
    id: 63,
    business_id: 10,
    image: "1701329891477Rectangle598.jpg",
    created_by: 72,
    created_at: "2023-11-30T07:38:11.000Z",
    updated_at: "2023-11-30T07:38:11.000Z",
  },
  {
    id: 64,
    business_id: 10,
    image: "1701329899378Rectangle599.jpg",
    created_by: 72,
    created_at: "2023-11-30T07:38:19.000Z",
    updated_at: "2023-11-30T07:38:19.000Z",
  },
  {
    id: 65,
    business_id: 10,
    image: "1701329902425Rectangle600.jpg",
    created_by: 72,
    created_at: "2023-11-30T07:38:22.000Z",
    updated_at: "2023-11-30T07:38:22.000Z",
  },
];

  const calendarInputRef = useRef(null);
  const testimonialArray = [
    {
      name: "Ernest Reinger",
      description:
        "Exceptional service from start to finish. The team at Ward Family Law handled my divorce case with professionalism and compassion. Highly recommended.",
      formCount: "0",
      image: "null",
    },
    {
      name: "Ernest Reinger",
      description:
        "Exceptional service from start to finish. The team at Ward Family Law handled my divorce case with professionalism and compassion. Highly recommended.",
      formCount: "1",
      image: "null",
    },
    {
      name: "Ernest Reinger",
      description:
        "I absolutely love the Constriction Services! They have exceeded my expectations in every way.",
      formCount: "2",
      image: "null",
    },
  ];

  const openCalendar = () => {
   
    if (calendarInputRef.current) {
      calendarInputRef.current.showPicker();
     
    }
  };
  return (
    <div>
      <div class="main-temaplt" id="temp38">
        <div className="container">
          <div className="row justify-content-center">
            <div style={{ width: "420px" }} className="col-12 wtemplate p-0">
              <article className="imgsechere sec">
                <img
                  src={bannerImage}
                  className="mx-auto d-block img-fluid coverimghere "
                />
                <img
                  src={logoImage}
                  className="mx-auto d-block img-fluid logo-profile"
                />
              </article>
              <article className="personalinfo sec">
                <h3 className="username">JENNY WILSON</h3>
                <p className="titleuser">Lawyer</p>
              </article>
              <article className="abouttemplate sec">
                <h3 class="sectitle">About me</h3>
                <p>
                  {`Advocate A.P Singh is a lawyer in Delhi, Noida well known for providing the best, finest, and exceptional legal services with his solution-focused approach in addition to his very smart attitude towards his work.`}
                </p>
              </article>

              <article class="contact sec">
                <h3 class="sectitle">Contact Info</h3>
                <ul class="conlink">
                  <li>
                    <a href="">
                      <i class="fa-solid fa-phone"></i>
                      <span>{`8010666660`}</span>
                    </a>
                  </li>

                  <li>
                    <a href="">
                      <i class="fa-solid fa-envelope"></i>
                      <span>{` jennywilson@gmail.com`}</span>
                    </a>
                  </li>


                  <li>
                    <a href="" style={{display:"flex"}}>
                      <i style={{minWidth:"40px"}} class="fa-solid fa-location-dot"></i>
                      <span>{`4517 Washington Ave. Manchester, Kentucky 39495 `}</span>
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i class="fa-solid fa-link"></i>
                      <span>{`www.jennywilson.com`}</span>
                    </a>
                  </li>
                  
                </ul>
              </article>
              <article className="servicesName sec">
                <h3 class="sectitle">Services </h3>
                <div className="mainservicebox">
                  <ul className="servesbox">
                    <li>Paternity</li>
                    <li>Child Custody</li>
                    <li>Legal Matters</li>
                    <li>Divorce</li>
                 
                  </ul>
                </div>
              </article>
              <TestimonialWrapper theme="temp38" />
              <article className="conatctform sec">
                <h3 class="sectitle">Contact</h3>
                <div class="contact-form">
                  <form>
                    <div class="col-12 mb-3">
                      <input
                        type="text"
                        class="form-control clear_string"
                        placeholder="Full Name"
                        name="last_name"
                        // value=""
                        required=""
                      />
                    </div>
                    <div class="col-12 mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Email"
                        name="email"
                        // value=""
                        required=""
                      />
                    </div>
                    <div class="col-12 mb-3">
                      <input
                        type="text"
                        class="form-control clear_string"
                        maxlength="10"
                        minlength="10"
                        placeholder="Mobile Number"
                        name="mobile_number"
                        // value=""
                        required=""
                      />
                    </div>
                    <div class="col-12 mb-3">
                      <textarea
                        class="form-control clear_string"
                        rows="3"
                        placeholder="Message*"
                        required=""
                        name="message"
                      ></textarea>
                    </div>

                    <div class="col-12 mb-3">
                      <button type="submit" class="btn btn-submitform">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </article>
              <article className="businessHours sec">
                <h3 class="sectitle">Business Hours</h3>

                <ul class="timelist">
                  <li>
                    <div className="day">Monday</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Tuesday</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Wednesday</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Thursday</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Friday</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                  <li>
                    <div className="day">Saturday</div>
                    <div className="time">
                      <span>8:00 AM</span>-<span>5:00 PM</span>
                    </div>
                  </li>
                </ul>
              </article>
              <article className="makeappitmneets sec">
                <h3 class="sectitle">Make Appointment</h3>
                <div className="contact-form">
                  <div class="col-12 mb-3" style={{position:"relative"}}>
                    <input
                      type="date"
                      ref={calendarInputRef}
                      class="form-control clear_string"
                      placeholder="Date"
                      name="currentDate"
                      // value={selectedDate}
                      // onChange={(e) => setSelectedDate(e.target.value)}
                    />
                     <div className="calanderIcon" onClick={openCalendar}><img loading="lazy" src={CalanderIconn} alt="Calendar Icon" style={{filter:"invert(1)"}}/></div>
                  </div>
                  <div class="col-12 mb-3">
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      // onChange={(e) => setSelectedTime(e.target.value)}
                    >
                      <option value="Select time">Select time</option>
                      <option>{`2:00 PM - 5:00 PM`}</option>
                    </select>
                  </div>
                  <div class="col-12 mb-3">
                    <button
                      className="btn btnmakeappitmnets"
                      data-bs-toggle="modal"
                      data-bs-target="#appotimnets"
                    >
                      Make An Appointment
                    </button>
                  </div>
                </div>
              </article>
              <PortfolioWrapper portfolioData={galleryArray} theme="temp38" />
              <article className="social-links-sec sec">
                <h3 class="sectitle">Social Links</h3>
                <ul class="socil-link">
                  <li>
                    <a>
                      <i class={`fa-brands fa-facebook`}></i>
                    </a>
                  </li>
                  <li>
                    <a>
                      <i class={`fa-brands fa-twitter`}></i>
                    </a>
                  </li>
                  <li>
                    <a>
                      <i class={`fa-brands fa-google`}></i>
                    </a>
                  </li>
                  <li>
                    <a>
                      <i class={`fa-brands fa-whatsapp`}></i>
                    </a>
                  </li>
                  <li>
                    <a>
                      <i class={`fa-brands fa-youtube`}></i>
                    </a>
                  </li>
                </ul>
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Theme38Template;
